export const setSelectedProjectFromStorage = (project) => {
  const selectedProjects = JSON.parse(sessionStorage.getItem('selectedProjects') || '[]');
  if (!selectedProjects.some(projectSelected => projectSelected.id === project.id)) {
    selectedProjects.push(project);
    sessionStorage.setItem('selectedProjects', JSON.stringify(selectedProjects));
  }
}

export const removeProjectFromStorage = (projectId) => {
  const selectedProjects = JSON.parse(sessionStorage.getItem('selectedProjects') || '[]');
  const index = selectedProjects.findIndex(project => project.id === projectId);

  if (index > -1) {
    selectedProjects.splice(index, 1);
    sessionStorage.setItem('selectedProjects', JSON.stringify(selectedProjects));
  }
}

export const getDataFromDownloadExcel = (projects) => {
  const selectedProjects = JSON.parse(sessionStorage.getItem('selectedProjects') || '[]');

  return selectedProjects.length > 0 
      ? selectedProjects.map((project: any) => flattenObject(project)) 
      : projects.map((project: any) => flattenObject(project));
}

export const flattenObject = (obj, parentKey = '', result = {}) => {
  for (let key in obj) {
    if (obj.hasOwnProperty(key)) {
      let propName = parentKey ? parentKey + '_' + key : key;

      if (typeof obj[key] === 'object' && obj[key] !== null && !Array.isArray(obj[key])) {
        flattenObject(obj[key], propName, result);
      } else {
        result[propName] = obj[key];
      }
    }
  }
  return result;
};